import { Component, OnInit, OnDestroy, HostBinding, ViewChild, ElementRef } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { MapPickerDialogService, MapPickerParams } from './map-picker-dialog-service';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { MapApiService } from 'src/app/model/api-services/map-api.service';

@Component({
	selector: 'app-map-picker-dialog',
	templateUrl: './map-picker-dialog.component.html',
	styleUrls: ['./map-picker-dialog.component.scss']
})
export class MapPickerDialogComponent implements OnInit {

	handler: AnyHandler;
	public title = 'Pick A Map';
	public views: Array<any> = [];
	public options: Array<any> = [];
	public hasItems = false;
	public items: Array<any> = [];
	public filterText = '';
	public viewsReady = false;
	public hasOptions = false;
	protected selectedView: any;
	@HostBinding('class.work-view') workView = true;
	@ViewChild('viewSel', { static: true }) viewSel: ElementRef;
	@ViewChild('optSel', { static: true }) optSel: ElementRef;
	constructor(private mapService: MapApiService, private activeModal: NgbActiveModal) { }

	ngOnInit() {
	}
	Show(params: MapPickerParams) {
		this.viewsReady = false;
		this.handler = params.handler;
		this.LoadItems();
		/* this.mapService.GetViews().then((response) => {
			this.views = [];
			for (const view in response.views) {
				if (response.views[view]) {
					if (!!response.views[view].options) {
						if (response.views[view].options.length <= 1) {
							continue;
						}
					}
					this.views.push(response.views[view]);
				}
			}
			setTimeout(() => {
				this.HandleView();
			}, 50);

		});
		*/
	}
	Ok() {

	}

	GetName(info) {
		if (!!info.label) {
			return info.label;
		}
		if (!!info.name) {
			return info.name;
		}
		return '';
	}
	GetValue(info) {
		if (!!info.value) {
			return info.value;
		}
		return '';
	}
	get filteredItems(): Array<any> {
		const filter = this.filterText.trim().toLowerCase();
		if (filter === '') {
			return this.items;
		}
		return this.items.filter((item) => {
			const id = (!!item.id) ? item.id.toString() : '';
			const name = (!!item.name) ? item.name.toString() : '';
			const description = (!!item.description) ? item.description.toString() : '';
			return `${id} ${name} ${description}`.toLowerCase().indexOf(filter) > -1;
		});
	}
	HandleView() {
		const view = this.views[this.viewSel.nativeElement.selectedIndex];
		this.selectedView = view;
		if (!!view.options) {
			this.hasOptions = view.options.length > 1;
			if (view.options.length > 1) {
				this.options = view.options.slice(0);
				setTimeout(() => {
					this.HandleOption({ target: { value: this.options[0].id } });
				}, 50);
			}
		} else {
			this.options = [];
			this.hasOptions = false;
			// this.LoadItems(this.selectedView);
		}


	}
	HandleOption(event) {
		if (!!this.selectedView) {
			const view = this.selectedView.wapi.replace('[id]', event.target.value);
			// this.LoadItems(view);
		}
	}
	LoadItems() {
		this.mapService.GetMine().then((answer) => {
			this.items = answer.response.results;
			this.hasItems = true;
		});
	}
	Select(item) {
		this.handler(item);
		this.activeModal.close();
	}
	Cancel() {
		this.activeModal.close();
	}

}

@Component({
	selector: 'app-map-picker-dialog-entry',
	template: ''
})
export class MapPickerDialogEntryComponent implements OnDestroy {
	modalRef: NgbModalRef;
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	lastTitle: string | null = null;

	constructor(private modalService: NgbModal, private service: MapPickerDialogService) {

		this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
			this.modalRef = this.modalService.open(MapPickerDialogComponent, { backdrop: 'static' });
			(this.modalRef.componentInstance as MapPickerDialogComponent).Show(info);
		});
	}
	ngOnDestroy(): void {
		this.subscriptionMgr.CancelSubscriptions();
	}
}
